// import { TextField, MenuItem, Select, FormControl, InputLabel } from "@mui/material";
// import TabsHeader from "../../../../Components/Shared/TabsHeader";
// import { UseFormReturn } from "react-hook-form";
// import { InnovationHistoricFinepModel } from "../../../../Models/InnovationHistoricFinepModel";
// import { useContext, useEffect, useState } from "react";
// import { toast } from "react-toastify";
// import { IResponseProps } from "../../../../Interfaces/IResponseProps";
// import useLoading from "../../../../Hooks/useLoading";
// import { PostInnovationHistoricFinepAPI, PutInnovationHistoricFinepAPI } from "../../../../API/InnovationHistoricFinepAPI";
// import Loader from "../../../../Components/Shared/Loader";
// import { TechnologicalFeaturesFinepContext } from "../../../../Contexts/TechnologicalFeaturesFinepContext";

// interface ProcessInnovationTabProps {
//     innovationHistoricForm: UseFormReturn<InnovationHistoricFinepModel, any>,
//     calculatePercentage: (isValidated: boolean, tabName: string, qtdFilled: number) => void,
//     getFilledThirdTabCount: (data: InnovationHistoricFinepModel) => number,
//     canValidateThirdTab: boolean,
//     setCanValidateThirdTab: React.Dispatch<React.SetStateAction<boolean>>
// }

// const InnovationHistoricFinep = (props: ProcessInnovationTabProps) => {
//     const { watch, setValue, register, handleSubmit, getValues, formState } = props.innovationHistoricForm;
//     const { isDirty } = formState;
//     const { toggleLoading, loading } = useLoading();
//     const [hasValidated, setHasValidated] = useState<boolean>(false);
//     const [totalValue, setTotalValue] = useState<number>(0);
//     const innovationHistoricFields = 4;

//     const watchIsValid = watch("isValid");
//     const watchingValues = watch();
//     const { handleFillTab } = useContext(TechnologicalFeaturesFinepContext);

//     const PostInnovationHistoricFinep = async (data: InnovationHistoricFinepModel) => {
//         try {
//             toggleLoading(true);

//             await PostInnovationHistoricFinepAPI(data).then((resp: IResponseProps) => {
//                 if (resp.statusCode == 200) {
//                     var dataResp = resp.data;

//                     var filled = props.getFilledThirdTabCount(dataResp);

//                     if (filled == innovationHistoricFields) {
//                         props.setCanValidateThirdTab(true);
//                     } else {
//                         props.setCanValidateThirdTab(false);
//                     }

//                     setValue('id', dataResp.id);

//                     handleFillTab(2);
//                     props.calculatePercentage(data.isValid, 'innovationHistoric', filled);
//                 }
//             });
//         } catch (error: any) {
//             toast.error(error);
//         } finally {
//             toggleLoading(false);
//         }
//     }

//     const PutInnovationHistoricFinep = async (data: InnovationHistoricFinepModel) => {
//         try {
//             toggleLoading(true);

//             await PutInnovationHistoricFinepAPI(data).then((resp: IResponseProps) => {
//                 if (resp.statusCode == 200) {
//                     var dataResp = resp.data;

//                     var filled = props.getFilledThirdTabCount(dataResp);

//                     if (filled == innovationHistoricFields) {
//                         props.setCanValidateThirdTab(true);
//                     } else {
//                         props.setCanValidateThirdTab(false);
//                     }

//                     handleFillTab(2);
//                     props.calculatePercentage(data.isValid, 'innovationHistoric', filled);
//                 }
//             });
//         } catch (error: any) {
//             toast.error(error);
//         } finally {
//             toggleLoading(false);
//         }
//     }

//     const EditFields = (data: InnovationHistoricFinepModel) => {
//         let value1 = JSON.parse(data.hasProcessIntroCompany.toString());
//         data.hasProcessIntroCompany = value1;
//         setValue('hasProcessIntroCompany', value1);

//         let value2 = JSON.parse(data.hasProcessIntroMarketing.toString());
//         data.hasProcessIntroMarketing = value2;
//         setValue('hasProcessIntroMarketing', value2);

//         return data;
//     }

//     const submitProcessInnovationForm = (data: InnovationHistoricFinepModel) => {
//         var dataEdit = EditFields(data);

//         if (isDirty || dataEdit.isValid != hasValidated) {
//             dataEdit.isValid = hasValidated;
//             setValue('isValid', hasValidated);

//             if (data.id != "") {
//                 PutInnovationHistoricFinep(dataEdit);
//             } else {
//                 PostInnovationHistoricFinep(dataEdit);
//             }
//         }
//     };

//     const getTotalValue = () => {
//         var operationIncomePercent = getValues('operationIncomePercent')?.toString();
//         var incomePercent = getValues('incomePercent')?.toString();

//         var total = (operationIncomePercent != undefined ? parseInt(operationIncomePercent) : 0) + (incomePercent != undefined ? parseInt(incomePercent) : 0);

//         setTotalValue(total);
//     }

//     const updateHasValidated = () => {
//         setHasValidated(props.canValidateThirdTab == true ? JSON.parse(getValues("isValid").toString()) : false);
//     }

//     useEffect(() => {
//         getTotalValue();
//     }, [watchingValues]);

//     useEffect(() => {
//         if (hasValidated.toString() != getValues("isValid").toString()) {
//             submitProcessInnovationForm(getValues());
//         }
//     }, [hasValidated]);

//     useEffect(() => {
//         updateHasValidated();
//     }, [watchIsValid, props.canValidateThirdTab]);

//     return (
//         <form onSubmit={handleSubmit(submitProcessInnovationForm)}>
//             {loading && <Loader />}
//             <div className="p-4 mb-2">
//                 <TabsHeader
//                     canValidate={props.canValidateThirdTab}
//                     setValueSelected={setHasValidated}
//                     valueSelected={hasValidated}
//                     registerId={getValues("registerId")}
//                     cardName="Características Tecnológicas"
//                     tabName="Histórico de Inovação"
//                 />

//                 <h4 className="mt-4">
//                     <strong className="color-blue">Inovação de Processo</strong>
//                 </h4>
//                 <div className="d-flex mt-4">
//                     <div className="me-4">
//                         <p>Percentual da receita operacional líquida oriundo de produtos novos ou significativamente aprimorados para a empresa, mas já existentes no mercado nacional, introduzidos nos últimos 3 anos:</p>
//                         <TextField
//                             type="number"
//                             disabled={hasValidated}
//                             {...register('operationIncomePercent', { onBlur: handleSubmit(submitProcessInnovationForm), valueAsNumber: true })}
//                         />
//                     </div>
//                     <div>
//                         <p>Percentual da receita líquida oriundo de produtos novos ou significamente aperfeiçoados para o mercado nacional ou mundial, introduzidos nos últimos 3 anos:</p>
//                         <TextField
//                             type="number"
//                             disabled={hasValidated}
//                             {...register('incomePercent', { onBlur: handleSubmit(submitProcessInnovationForm), valueAsNumber: true })}
//                         />
//                     </div>
//                     <div>
//                         <TextField type="text" disabled className="mt-4 w-50" label="Total %" value={totalValue} />
//                     </div>
//                 </div>

//                 <div className="d-flex align-items-center justify-content-between mt-4">
//                     <strong className="me-4">Houve introdução de processo novo ou significamente aperfeiçoado para a empresa, mas existente no mercado nacional nos últimos três anos?</strong>
//                     <FormControl className="mt-2 w-75">
//                         <InputLabel id="select-new-process">Selecione</InputLabel>
//                         <Select
//                             placeholder="Selecione"
//                             className="w-100"
//                             label="Selecione"
//                             disabled={hasValidated}
//                             labelId="select-new-process"
//                             {...register('hasProcessIntroCompany', { onBlur: handleSubmit(submitProcessInnovationForm) })}
//                             value={getValues('hasProcessIntroCompany')?.toString()}
//                         >
//                             <MenuItem value="true">Sim</MenuItem>
//                             <MenuItem value="false">Não</MenuItem>
//                         </Select>
//                     </FormControl>
//                 </div>
//                 <div className="d-flex align-items-center justify-content-between mt-4">
//                     <strong className="me-4">Houve introdução de processos novo ou significamente aperfeiçoado para o mercado nacional ou mundial nos últimos 3 anos?</strong>
//                     <FormControl className="mt-2 w-75">
//                         <InputLabel id="select-new-process-three">Selecione</InputLabel>
//                         <Select
//                             placeholder="Selecione"
//                             className="w-100"
//                             label="Selecione"
//                             disabled={hasValidated}
//                             labelId="select-new-process-three"
//                             {...register('hasProcessIntroMarketing', { onBlur: handleSubmit(submitProcessInnovationForm) })}
//                             value={getValues('hasProcessIntroMarketing')?.toString()}
//                         >
//                             <MenuItem value="true">Sim</MenuItem>
//                             <MenuItem value="false">Não</MenuItem>
//                         </Select>
//                     </FormControl>
//                 </div>
//                 <div className="mb-2 mt-4 me-2 mb-4">
//                     <TextField
//                         type="text"
//                         multiline
//                         rows={3}
//                         disabled={hasValidated}
//                         label="Descreva os principais processos novos ou significativamente aprimorados implementados na empresa nos últimos 3 anos, explicitando seus diferenciais e como estão relacionados com a estratégia da empresa"
//                         className="w-75"
//                         {...register('mainDifferentials', { onBlur: handleSubmit(submitProcessInnovationForm) })}
//                     />
//                 </div>
//             </div>
//         </form>
//     );
// };

// export default InnovationHistoricFinep;

















import { Input, Select, Form, Typography, Radio, Space, Row, Col } from "antd";
import TabsHeader from "../../../../Components/Shared/TabsHeader";
import { UseFormReturn } from "react-hook-form";
import { InnovationHistoricFinepModel } from "../../../../Models/InnovationHistoricFinepModel";
import { useContext, useEffect, useState } from "react";
import { toast } from "react-toastify";
import { IResponseProps } from "../../../../Interfaces/IResponseProps";
import useLoading from "../../../../Hooks/useLoading";
import { PostInnovationHistoricFinepAPI, PutInnovationHistoricFinepAPI } from "../../../../API/InnovationHistoricFinepAPI";
import Loader from "../../../../Components/Shared/Loader";
import { TechnologicalFeaturesFinepContext } from "../../../../Contexts/TechnologicalFeaturesFinepContext";

const { TextArea } = Input;
const { Title, Text } = Typography;
const { Option } = Select;

interface ProcessInnovationTabProps {
    innovationHistoricForm: UseFormReturn<InnovationHistoricFinepModel, any>,
    calculatePercentage: (isValidated: boolean, tabName: string, qtdFilled: number) => void,
    getFilledThirdTabCount: (data: InnovationHistoricFinepModel) => number,
    canValidateThirdTab: boolean,
    setCanValidateThirdTab: React.Dispatch<React.SetStateAction<boolean>>
}

const InnovationHistoricFinep = (props: ProcessInnovationTabProps) => {
    const { watch, setValue, register, handleSubmit, getValues, formState } = props.innovationHistoricForm;
    const { isDirty } = formState;
    const { toggleLoading, loading } = useLoading();
    const [hasValidated, setHasValidated] = useState<boolean>(false);
    const [totalValue, setTotalValue] = useState<number>(0);
    const innovationHistoricFields = 4;

    const watchIsValid = watch("isValid");
    const watchingValues = watch();
    const { handleFillTab } = useContext(TechnologicalFeaturesFinepContext);

    const PostInnovationHistoricFinep = async (data: InnovationHistoricFinepModel) => {
        try {
            toggleLoading(true);

            await PostInnovationHistoricFinepAPI(data).then((resp: IResponseProps) => {
                if (resp.statusCode == 200) {
                    var dataResp = resp.data;

                    var filled = props.getFilledThirdTabCount(dataResp);

                    if (filled == innovationHistoricFields) {
                        props.setCanValidateThirdTab(true);
                    } else {
                        props.setCanValidateThirdTab(false);
                    }

                    setValue('id', dataResp.id);

                    handleFillTab(2);
                    props.calculatePercentage(data.isValid, 'innovationHistoric', filled);
                }
            });
        } catch (error: any) {
            toast.error(error);
        } finally {
            toggleLoading(false);
        }
    }

    const PutInnovationHistoricFinep = async (data: InnovationHistoricFinepModel) => {
        try {
            toggleLoading(true);

            await PutInnovationHistoricFinepAPI(data).then((resp: IResponseProps) => {
                if (resp.statusCode == 200) {
                    var dataResp = resp.data;

                    var filled = props.getFilledThirdTabCount(dataResp);

                    if (filled == innovationHistoricFields) {
                        props.setCanValidateThirdTab(true);
                    } else {
                        props.setCanValidateThirdTab(false);
                    }

                    handleFillTab(2);
                    props.calculatePercentage(data.isValid, 'innovationHistoric', filled);
                }
            });
        } catch (error: any) {
            toast.error(error);
        } finally {
            toggleLoading(false);
        }
    }

    const EditFields = (data: InnovationHistoricFinepModel) => {
        let value1 = JSON.parse(data.hasProcessIntroCompany.toString());
        data.hasProcessIntroCompany = value1;
        setValue('hasProcessIntroCompany', value1);

        let value2 = JSON.parse(data.hasProcessIntroMarketing.toString());
        data.hasProcessIntroMarketing = value2;
        setValue('hasProcessIntroMarketing', value2);

        return data;
    }

    const submitProcessInnovationForm = (data: InnovationHistoricFinepModel) => {
        var dataEdit = EditFields(data);

        if (isDirty || dataEdit.isValid != hasValidated) {
            dataEdit.isValid = hasValidated;
            setValue('isValid', hasValidated);

            if (data.id != "") {
                PutInnovationHistoricFinep(dataEdit);
            } else {
                PostInnovationHistoricFinep(dataEdit);
            }
        }
    };

    const getTotalValue = () => {
        var operationIncomePercent = getValues('operationIncomePercent')?.toString();
        var incomePercent = getValues('incomePercent')?.toString();

        var total = (operationIncomePercent != undefined ? parseInt(operationIncomePercent) : 0) + (incomePercent != undefined ? parseInt(incomePercent) : 0);

        setTotalValue(total);
    }

    const updateHasValidated = () => {
        setHasValidated(props.canValidateThirdTab == true ? JSON.parse(getValues("isValid").toString()) : false);
    }

    useEffect(() => {
        getTotalValue();
    }, [watchingValues]);

    useEffect(() => {
        if (hasValidated.toString() != getValues("isValid").toString()) {
            submitProcessInnovationForm(getValues());
        }
    }, [hasValidated]);

    useEffect(() => {
        updateHasValidated();
    }, [watchIsValid, props.canValidateThirdTab]);

    return (
        <form onSubmit={handleSubmit(submitProcessInnovationForm)}>
            {loading && <Loader />}
            <div className="p-4 mb-2">
                <TabsHeader
                    canValidate={props.canValidateThirdTab}
                    setValueSelected={setHasValidated}
                    valueSelected={hasValidated}
                    registerId={getValues("registerId")}
                    cardName=""
                    tabName=""
                />
                <Title level={4} style={{ color: '#000085', fontSize: '22px', fontWeight: 'normal' }}>Inovação de Processo</Title>
                <Row gutter={16} align="bottom" className="mt-4">
                    <Col span={8}>
                        <Text style={{ fontSize: 14 }}>Percentual da receita operacional líquida oriundo de produtos novos ou significativamente aprimorados para a empresa, mas já existentes no mercado nacional, introduzidos nos últimos 3 anos:</Text>
                        <Input
                            type="number"
                            disabled={hasValidated}
                            {...register('operationIncomePercent', {
                                onBlur: handleSubmit(submitProcessInnovationForm),
                                valueAsNumber: true,
                                setValueAs: (v) => v === '' ? null : Number(v)
                            })}
                            value={getValues('operationIncomePercent') ?? ''}
                            style={{ width: '100%' }}
                        />
                    </Col>
                    <Col span={8}>
                        <Text style={{ fontSize: 14 }}>Percentual da receita líquida oriundo de produtos novos ou significamente aperfeiçoados para o mercado nacional ou mundial, introduzidos nos últimos 3 anos:</Text>
                        <Input
                            type="number"
                            disabled={hasValidated}
                            {...register('incomePercent', {
                                onBlur: handleSubmit(submitProcessInnovationForm),
                                valueAsNumber: true,
                                setValueAs: (v) => v === '' ? null : Number(v)
                            })}
                            value={getValues('incomePercent') ?? ''}
                            style={{ width: '100%' }}
                        />
                    </Col>
                    <Col span={8}>
                        <Text style={{ fontSize: 14 }}>Total:</Text>
                        <Input
                            type="text"
                            disabled
                            style={{ width: '100%' }}
                            value={totalValue}
                        />
                    </Col>
                </Row>
                <div className="mt-4">
                    <Text >Houve introdução de processo novo ou significamente aperfeiçoado para a empresa, mas existente no mercado nacional nos últimos três anos?</Text>
                    <div className="mt-2">

                        <Radio.Group
                            disabled={hasValidated}
                            {...register('hasProcessIntroCompany', { onBlur: handleSubmit(submitProcessInnovationForm) })}
                            value={getValues('hasProcessIntroCompany') ? getValues('hasProcessIntroCompany').toString() : undefined}
                        >
                            <Space>
                                <Radio value="true">Sim</Radio>
                                <Radio value="false">Não</Radio>
                            </Space>
                        </Radio.Group>
                    </div>
                </div>
                <div className="mt-4">
                    <Text >Houve introdução de processos novo ou significamente aperfeiçoado para o mercado nacional ou mundial nos últimos 3 anos?</Text>
                    <div className="mt-2">
                        <Radio.Group
                            disabled={hasValidated}
                            {...register('hasProcessIntroMarketing', { onBlur: handleSubmit(submitProcessInnovationForm) })}
                            value={getValues('hasProcessIntroMarketing') ? getValues('hasProcessIntroMarketing').toString() : undefined}
                        >
                            <Space>
                                <Radio value="true">Sim</Radio>
                                <Radio value="false">Não</Radio>
                            </Space>
                        </Radio.Group>
                    </div>
                </div>
                <div className="mb-2 mt-4 me-2 mb-4">
                    <Text>Descreva os principais processos novos ou significativamente aprimorados implementados na empresa nos últimos 3 anos, explicitando seus diferenciais e como estão relacionados com a estratégia da empresa</Text>
                    <TextArea
                    placeholder="Descreva aqui..."
                        disabled={hasValidated}
                        className="w-100"
                        rows={3}
                        {...register('mainDifferentials', { onBlur: handleSubmit(submitProcessInnovationForm) })}
                    />
                </div>
            </div>
        </form >
    );
};

export default InnovationHistoricFinep;